import './CampaignDetails.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import { GET_ALL_CAMPAIGN, GET_EDITOR_OUTBOUND_FIELDS, GET_SEQUENCE_THREAD } from '../../gql/campaign/queries';
import { Row, Col, Modal } from 'react-bootstrap';
import RightArrow from '../../assets/images/right-arrow.svg';
import { Editor } from '@tinymce/tinymce-react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useMutation } from '@apollo/client';
import { SIGNATURE_UPLOAD_FILE } from '../../gql/signature/mutation';
import { GET_CAMPAIGN_DETAILS_BY_ID, ADD_SEQUENCE_DATA } from '../../gql/campaign/mutation';
import { Spinner } from 'react-bootstrap';
import useUnsavedChangeWarning from '../../hooks/useUnsavedChangeWarning';
import EmailIcon from '../../assets/images/email-icon.svg';
import TextIcon from '../../assets/images/text-provider.svg';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { GET_PROFILE } from '../../gql/auth/queries';
import editIcon from '../../assets/images/EditActivity.svg';
import warningIcon from '../../assets/images/warningIcon.svg';
import playIcon from '../../assets/images/play-icon.png';
import { v4 as uuidv4 } from 'uuid';
import { UPDATE_CAMPAIGN_STATUS } from '../../gql/campaign/mutation';

function CampaignDetails() {

    const { id } = useParams()
    const history = useHistory()
    const [allCampaign, setAllCampaign] = useState([])
    const [clickedCampaign, setClickedCampaign] = useState({})
    const [provider, setProvider] = useState('')
    const editorEmailRef = useRef(null);
    const editorTextRef = useRef(null);
    const sequenceSlideRef = useRef(null);
    const [sequence, setSequence] = useState([])
    const [showBox, setShowBox] = useState(false)
    const [waitBox, setWaitBox] = useState(false)
    const [editableIndex, setEditableIndex] = useState(0)
    const [subject, setSubject] = useState('')
    // eslint-disable-next-line
    const [emailEditorData, setEmailEditorData] = useState({})
    // eslint-disable-next-line
    const [textEditorData, setTextEditorData] = useState({})
    const [waitFor, setWaitFor] = useState(0)
    const [errorMessage, setErrorMessage] = useState('')
    const [addSequenceDataSuccess, setAddSequenceDataSuccess] = useState(false)
    const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning()
    const [textProvider, setTextProvider] = useState(null)
    const [emailProvider, setEmailProvider] = useState(null)
    const [smShow, setSmShow] = useState(false);
    const [smShow2, setSmShow2] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState('')
    const [liIndex, setLiIndex] = useState(null)
    const [updateSuccess, setUpdateSuccess] = useState(false)
    const [updatePlaySuccess, setUpdatePlaySuccess] = useState(false)
    //eslint-disable-next-line
    const [campaignStarted, setCampaignStarted] = useState(false)
    const [updatePauseSuccess, setUpdatePauseSuccess] = useState(false)
    const [messageTiny, setMessageTiny] = useState('')
    const [smsTiny, setSmsTiny] = useState('')
    const [sequenceThreadData, setSequenceThreadData] = useState([])
    const [campaignRunning, setCampaignRunning] = useState(false)

    const [getAllCampaign] = useLazyQuery(GET_ALL_CAMPAIGN, {
        onCompleted(data) {
            setAllCampaign(data?.getAllCampaign)
        }
    })

    const [getProfile] = useLazyQuery(GET_PROFILE, {
        onCompleted(data) {
            setTextProvider(data?.me?.textProvider)
            setEmailProvider(data?.me?.emailProvider)
        }
    })

    const [getCampaignById] = useMutation(GET_CAMPAIGN_DETAILS_BY_ID, {
        onCompleted(data) {
            if (data?.getAllSequences) {
                setClickedCampaign(data.getAllSequences)
                setSequence(data.getAllSequences.sequence)
                setWaitBox(true)
                setCampaignRunning(data.getAllSequences.campaignStarted)

                if (data?.getAllSequences?.campaignType === 'autoScript') {
                    setProvider(data?.getAllSequences?.sequence[0].seqType === 'Email' ? 'email' : 'text')
                    setEditableIndex(data?.getAllSequences?.sequence[0].order - 1)
                    filterData(data?.getAllSequences?.sequence[0])
                    setLiIndex(0)
                }
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        fetchPolicy: 'network-only'
    })

    const [uploadFile] = useMutation(SIGNATURE_UPLOAD_FILE, {
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    });

    const [addSequenceData, { loading }] = useMutation(ADD_SEQUENCE_DATA, {
        onCompleted(data) {
            setAddSequenceDataSuccess(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    const [getEditorOutboundFields] = useLazyQuery(GET_EDITOR_OUTBOUND_FIELDS, {
        onCompleted(data) {
        },
        fetchPolicy: 'network-only'
    })

    const [updateCampaignStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
        onCompleted(data) {
            if (data?.updateCampaignStatus) {
                setUpdateSuccess(true)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        refetchQueries: [
            'GetAllCampaign'
        ]
    })

    const [updateCampaignPlayStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
        onCompleted(data) {
            if (data?.updateCampaignStatus) {
                setClickedCampaign({
                    ...clickedCampaign,
                    campaignStarted: true
                })
                setUpdatePlaySuccess(true)
                setCampaignStarted(true)
                setCampaignRunning(true)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        refetchQueries: [
            'GetAllCampaign'
        ]
    })

    const [updateCampaignPauseStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
        onCompleted(data) {
            if (data?.updateCampaignStatus) {
                setClickedCampaign({
                    ...clickedCampaign,
                    campaignStarted: false
                })
                setUpdatePauseSuccess(true)
                setCampaignStarted(false)
                setCampaignRunning(false)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        refetchQueries: [
            'GetAllCampaign'
        ]
    })

    const [getSequenceThread] = useLazyQuery(GET_SEQUENCE_THREAD, {
        onCompleted(data) {
            setSequenceThreadData(data?.getSequenceSubjects)
        }
    })

    useEffect(() => {
        getAllCampaign()
        getProfile()
        // getEditorOutboundFields()

        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (id) {
            getCampaignById({
                variables: {
                    getSequenceArgs: {
                        campaignId: id
                    }
                }
            })
            setPristine()
            setProvider('')
        }

        //eslint-disable-next-line
    }, [id])

    useEffect(() => {
        getSequenceThread({
            variables: {
                campaignId: id
            }
        })

        //eslint-disable-next-line
    }, [id, addSequenceDataSuccess])


    const editorDropDown = async (editor) => {
        let { data } = await getEditorOutboundFields({
            variables: {
                campaignId: id
            }
        })
        const result = data.getEditorOutboundFields && data.getEditorOutboundFields.map((item) => {
            return {
                type: item.type,
                text: item.fieldName,
                value: item.fieldValue,
                onAction: function () {
                    editor.insertContent(`&nbsp;<em>${item?.fieldValue}</em>`);
                }
            }
        })

        return result ?? []
    }

    const handleAddNewStep = () => {
        setIsDirty()
        setProvider('')
        setShowBox(true)
        setEmailEditorData({})
        setTextEditorData({})
        setSubject('')
        setMessageTiny('')
        setSmsTiny('')
    }

    const handleEmailEditorChange = () => {
        // setIsDirty()
        let editorEmailData;
        if (editorEmailRef.current) {
            editorEmailData = editorEmailRef.current.getContent()
        }

        if (editorEmailData) {
            sequence[editableIndex]['message'] = editorEmailData
            sequence[editableIndex]['subject'] = subject
        }

        setMessageTiny(editorEmailData)

        setSequence(sequence)
    }

    const handleTextEditorChange = () => {
        // setIsDirty()
        let editorTextData;
        if (editorTextRef.current) {
            editorTextData = editorTextRef.current.getContent()
        }

        if (editorTextData) {
            sequence[editableIndex]['message'] = editorTextData
        }
        setSmsTiny(editorTextData)
        setSequence(sequence)
    }

    async function filterData(sequence) {
        if (sequence.seqType === 'Email') {
            setSubject(sequence.subject)
            setEmailEditorData({ subject: sequence.subject, message: sequence.message })
            setMessageTiny(sequence.message)
        }
        else if (sequence.seqType === 'SMS') {
            setTextEditorData({ message: sequence.message })
            setSmsTiny(sequence.message)
        }
    }

    async function handleDeleteSequence(sequence, index) {
        const filteredPermission = [...sequence]
        filteredPermission.splice(index, 1)
        filteredPermission.map((item, ind) => item['order'] = ind + 1)
        setSequence(filteredPermission)
        setProvider('')

        const deleteResponse = await addSequenceData({
            variables: {
                addSequenceInput: {
                    campaignId: id,
                    sequenceData: filteredPermission
                }
            }
        })

        if (deleteResponse?.data?.addCampaignSequences) {
            setSmShow(false)
        }


    }

    const handleSave = () => { 
        if (!id) {
            toast.error('Campaign Id Required.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }

        addSequenceData({
            variables: {
                addSequenceInput: {
                    campaignId: id,
                    sequenceData: sequence
                }
            }
        })
    }

    const uploadImage = async (file) => {
        let returedData;
        if (file) {
            returedData = await uploadFile({
                variables: {
                    file: file
                }
            })
        }
        if (returedData) {
            if (returedData?.data?.uploadSignatureFile?.url) {
                // const data = baseUrl+returedData.data.uploadProfileImage.new_file_key
                const data = returedData?.data?.uploadSignatureFile?.url
                return data
            }
        }
    }

    // Email Editor Image

    if (errorMessage) {
        toast.error(errorMessage, {
            position: "bottom-right",
            closeOnClick: true,
        })
        setErrorMessage('')
    }

    if (addSequenceDataSuccess) {
        setPristine()
        toast.success("Successfully Saved.", {
            position: "bottom-right",
        })
        setAddSequenceDataSuccess(false)
    }

    const onDragEnd = (result, sequence, setSequence) => {
        if (!result.destination) return;
        const { source, destination } = result;
        setIsDirty()

        let destinationValue = sequence.filter((item) => item._id === destination?.droppableId)[0]  // order1  ye hai jaha pe drop hoga uska box ka value  1 ka value
        let sourceValue = sequence.filter((item) => item._id === source?.droppableId)[0]  //order 2  jo app drop krna chahate ho uska box ka value

        let destinationValue_order = destinationValue.order
        let sourceValue_order = sourceValue.order

        let destinationValue_id = destinationValue._id
        let sourceValue_id = sourceValue._id

        let destinationValue_waitFor = destinationValue.waitFor
        let sourceValue_waitFor = sourceValue.waitFor

        const copiedItems = [...sequence]
        const [removed] = copiedItems.splice(source.index, 1); 

        copiedItems.splice(destination.index, 0, removed);

        copiedItems.map((item, ind) => {
            if (item._id === destinationValue_id) {
                item.order = sourceValue_order
                item.waitFor = sourceValue_waitFor
            }
            if (item._id === sourceValue_id) {
                item.order = destinationValue_order
                item.waitFor = destinationValue_waitFor
            }
            if (+item.order === 1) {
                item.waitFor = 0
            }
            return item
        })

        setSequence(copiedItems)

    };

    const handleDeleteCampaign = () => {
        if (!id) {
            setSmShow2(false)
            return toast.error('Choose Campaign First.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }
        updateCampaignStatus({
            variables: {
                updateCampaignStatusInput: {
                    campaignId: id,
                    campaignStatus: 'DELETE'
                }
            }
        })
    }

    if (updateSuccess) {
        setSmShow2(false)
        setSequence([])
        setProvider('')
        setClickedCampaign({})
        history.push('/campaigns/campaign-details')
        toast.success('Campaign Deleted.', {
            position: "bottom-right",
            closeOnClick: true,
        })
        setUpdateSuccess(false)
    }

    const handlePause = () => {
        if (!id) {
            setSmShow2(false)
            return toast.error('Choose Campaign First.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }
        updateCampaignPauseStatus({
            variables: {
                updateCampaignStatusInput: {
                    campaignId: id,
                    campaignStatus: 'PAUSE'
                }
            }
        })
    }

    const handlePlay = () => {
        if (!id) {
            setSmShow2(false)
            return toast.error('Choose Campaign First.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }
        updateCampaignPlayStatus({
            variables: {
                updateCampaignStatusInput: {
                    campaignId: id,
                    campaignStatus: 'START'
                }
            }
        })
    }

    if (updatePlaySuccess) {
        toast.success('Campaign Started.', {
            position: "bottom-right",
            closeOnClick: true,
        })
        setUpdatePlaySuccess(false)
    }

    if (updatePauseSuccess) {
        toast.success('Campaign Paused.', {
            position: "bottom-right",
            closeOnClick: true,
        })
        setUpdatePauseSuccess(false)
    }

    return (
        <>
            {/* <CampaignsSidebar allCampaign={allCampaign} /> */}

            <div className='campaign-sidebar'>
                <div className='title'>
                    <h4>Campaigns</h4>
                </div>
                <div className='campaign_list_container' >
                    <ul>
                        {
                            allCampaign && allCampaign.length > 0 && allCampaign.map((item, i) => {
                                if (item?.campaignStatus !== 'delete' && (item?.campaignType === 'autoScript' && item?.sequence.length > 0)) {
                                    return <li key={item?._id} style={{ backgroundColor: item?._id === id ? '#F5F7FB' : '#FFFFFF' }}  >
                                        <Link to={`/campaigns/campaign-details/${item?._id}`}
                                            onClick={(e) => {
                                                if (setIsDirty() === true) {
                                                    e.preventDefault()
                                                    return
                                                }
                                                if (setIsDirty() === false) {
                                                    setClickedCampaign(item)
                                                    setProvider('')
                                                }
                                            }}
                                        >
                                            {item?.campaignName}
                                        </Link>
                                    </li>
                                }
                                else if (item?.campaignStatus !== 'delete' && (item?.campaignType === 'manualScript')) {
                                    return <li key={item?._id} style={{ backgroundColor: item?._id === id ? '#F5F7FB' : '#FFFFFF' }}  >
                                        <Link to={`/campaigns/campaign-details/${item?._id}`}
                                            onClick={(e) => {
                                                if (setIsDirty() === true) {
                                                    e.preventDefault()
                                                    return
                                                }
                                                if (setIsDirty() === false) {
                                                    setClickedCampaign(item)
                                                    setProvider('')
                                                }
                                            }}
                                        >
                                            {item?.campaignName}
                                        </Link>
                                    </li>
                                }
                                return false
                            })
                        }
                    </ul>
                </div>
                <div className='create-camp-btn'>
                    <button className='solid-button'
                        onClick={() => {
                            setIsDirty()
                            history.push('/campaign-name')
                        }}
                    >
                        Create New Campaigns
                    </button>
                </div>
            </div>

            <div className='campaign-details'>
                <div className='title-btn-container'>
                    <h1>{clickedCampaign?.campaignName}</h1>
                    <div className='btn-container'>
                        <button className='play-pause-btn'>
                            {
                                clickedCampaign?.campaignStarted === true ?
                                    <span className='pause' onClick={handlePause} >
                                        <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.5 1H1V15H4.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M11.5 1H8V15H11.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        Pause
                                    </span>
                                    :
                                    <span className='play' onClick={handlePlay} >
                                        <img src={playIcon} alt="play" width="20" height="20" />
                                        Play
                                    </span>

                            }
                        </button>
                        {
                            sequence.length === 0 ?
                                <button className='solid-button' style={{ opacity: 0.6, cursor: "not-allowed" }} >Save</button>
                                : loading ?
                                    <button className='solid-button' >Save &nbsp;
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    </button>
                                    :
                                    <button className='solid-button' onClick={handleSave} >Save</button>

                        }
                        <button className='delete-btn' onClick={() => setSmShow2(true)} >
                            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.998047 4.40332H2.86471H17.798" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5.66719 4.39935V2.53268C5.66719 2.03761 5.86385 1.56282 6.21392 1.21275C6.56399 0.862682 7.03878 0.666016 7.53385 0.666016H11.2672C11.7623 0.666016 12.2371 0.862682 12.5871 1.21275C12.9372 1.56282 13.1339 2.03761 13.1339 2.53268V4.39935M15.9339 4.39935V17.466C15.9339 17.9611 15.7372 18.4359 15.3871 18.7859C15.0371 19.136 14.5623 19.3327 14.0672 19.3327H4.73385C4.23878 19.3327 3.76399 19.136 3.41392 18.7859C3.06385 18.4359 2.86719 17.9611 2.86719 17.466V4.39935H15.9339Z" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <ul className='campaign-detail-tabs'>
                    <li className="tab_sequence" >
                        <Link to={id ? `/campaigns/leads/${id}` : '/campaigns/leads'} >Leads</Link>
                    </li>
                    <li className='active'>
                        <Link to='#'>Sequence</Link>
                    </li>
                    <li className="tab_sequence" >
                        <Link to={id ? `/campaigns/schedule/${id}` : '/campaigns/schedule'}>Schedules</Link>
                    </li>
                    <li className="tab_sequence" >
                        <Link to={id ? `/campaigns/setup/${id}` : '/campaigns/setup'} >Setup</Link>
                    </li>
                </ul>
                {/* <CampaignsSequence /> */}

                <div className='sequence-container'>
                    <div className='sequence-wrap'>
                        <DragDropContext
                            onDragEnd={(result) => {
                                onDragEnd(result, sequence, setSequence)
                            }}
                        >
                            <div className='sequence-list parent' id='scroll_parent' >
                                <div className='sequence_list_wrapper child_one' id='scroll_child' ref={sequenceSlideRef} >
                                    <ul >
                                        {
                                            //eslint-disable-next-line
                                            sequence.length > 0 && sequence.sort((a, b) => a.order > b.order && 1 || -1).map((item, i) => {
                                                if (item.seqType === 'Email' || item.seqType === 'SMS') {
                                                    return (
                                                        <Droppable droppableId={item?._id} key={item?._id}>
                                                            {
                                                                (provided, snapshot) => {
                                                                    return (
                                                                        <div
                                                                            {...provided.droppableProps}
                                                                            ref={provided.innerRef}
                                                                        >
                                                                            <Draggable
                                                                                key={item?._id}
                                                                                draggableId={item?._id}
                                                                                index={i}
                                                                                isDragDisabled={campaignRunning}
                                                                            >
                                                                                {
                                                                                    (provided, snapshot) => {
                                                                                        return (
                                                                                            <div
                                                                                                ref={provided.innerRef}
                                                                                                {...provided.draggableProps}
                                                                                                {...provided.dragHandleProps}
                                                                                                style={{
                                                                                                    ...provided.draggableProps.style
                                                                                                }}
                                                                                            >
                                                                                                <li className='' key={i} style={{ border: i === liIndex ? "1px solid #206FFD" : "1px solid rgba(32, 111, 253, 0.35)" }} >
                                                                                                    <div className='title-container title_container_border'>
                                                                                                        <span className='counter-number'>{item.order}</span>
                                                                                                        {/* <p>New sequence</p> */}
                                                                                                        <p style={{ cursor: 'pointer' }}
                                                                                                            onClick={() => {
                                                                                                                setProvider(item.seqType === 'Email' ? 'email' : 'text')
                                                                                                                setEditableIndex(item.order - 1)
                                                                                                                filterData(item)
                                                                                                                setLiIndex(i)
                                                                                                                document.getElementById('thread_select').selectedIndex = 0;
                                                                                                            }}
                                                                                                        >
                                                                                                            {item?.seqType ?? "New sequence"}
                                                                                                        </p>

                                                                                                        <div>
                                                                                                            <button className='edit_sequence'
                                                                                                                onClick={() => {
                                                                                                                    setProvider(item.seqType === 'Email' ? 'email' : 'text')
                                                                                                                    setEditableIndex(item.order - 1)
                                                                                                                    filterData(item)
                                                                                                                    setLiIndex(i)
                                                                                                                    document.getElementById('thread_select').selectedIndex = 0;
                                                                                                                }}
                                                                                                            >
                                                                                                                <img src={editIcon} alt='edit' />
                                                                                                            </button>

                                                                                                            <button className='delete-sequence-step' onClick={() => {
                                                                                                                setDeleteIndex(item.order - 1)
                                                                                                                setSmShow(true)
                                                                                                            }}>
                                                                                                                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                    <path d="M0.998047 4.40332H2.86471H17.798" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                                    <path d="M5.66719 4.39935V2.53268C5.66719 2.03761 5.86385 1.56282 6.21392 1.21275C6.56399 0.862682 7.03878 0.666016 7.53385 0.666016H11.2672C11.7623 0.666016 12.2371 0.862682 12.5871 1.21275C12.9372 1.56282 13.1339 2.03761 13.1339 2.53268V4.39935M15.9339 4.39935V17.466C15.9339 17.9611 15.7372 18.4359 15.3871 18.7859C15.0371 19.136 14.5623 19.3327 14.0672 19.3327H4.73385C4.23878 19.3327 3.76399 19.136 3.41392 18.7859C3.06385 18.4359 2.86719 17.9611 2.86719 17.466V4.39935H15.9339Z" stroke="#0A1E43" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                                </svg>
                                                                                                            </button>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className='step-content' >
                                                                                                        {
                                                                                                            item?.seqType === 'Email' && (
                                                                                                                <>
                                                                                                                    <span className='not-configured' style={{ color: '#206FFD', background: '#DFEAFF' }} >
                                                                                                                        {item?.seqType === 'Email' ? 'Send Email' : ''}
                                                                                                                    </span>
                                                                                                                    <span className='emailSubject' >
                                                                                                                        {item?.seqType === 'Email' ? item.subject.length > 19 ? item.subject.slice(0, 16) + ' ...' : item.subject : ''}
                                                                                                                    </span>
                                                                                                                </>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>

                                                                                                    {
                                                                                                        (item.order > 1 && waitBox === true) &&
                                                                                                        <div className='wait_for_container' >
                                                                                                            <p>Send after
                                                                                                                <input className='wait_for'
                                                                                                                    type="number"
                                                                                                                    min="0"
                                                                                                                    value={item?.waitFor >= 0 ? item?.waitFor : waitFor}
                                                                                                                    onChange={(e) => {
                                                                                                                        setIsDirty() // --> change onKeyUp
                                                                                                                        sequence[item.order - 1]['waitFor'] = +e.target.value
                                                                                                                        setWaitFor(item?._id ? item?.waitFor : e.target.value)
                                                                                                                    }}
                                                                                                                />
                                                                                                                days
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    }


                                                                                                </li>
                                                                                            </div>
                                                                                        );
                                                                                    }}
                                                                            </Draggable>
                                                                            {provided.placeholder}
                                                                        </div>
                                                                    );
                                                                }}
                                                        </Droppable>
                                                    )
                                                } else {
                                                    return false;
                                                }
                                            })
                                        }

                                        {
                                            (sequence.length === 0 || showBox === true) &&
                                            <li className='' >
                                                <div className='title-container'>
                                                    <span className='counter-number'>{sequence.length === 0 ? 1 : sequence.length + 1}</span>
                                                    <p>New sequence</p>
                                                </div>
                                                <div className='step-content'>
                                                    <span className='not-configured'>Not Configured</span>
                                                </div>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                {
                                    !provider ?
                                        <button className='add-step' style={{ opacity: 0.7 }} disabled  >Add a new step</button>
                                        :
                                        <button className='add-step' onClick={handleAddNewStep}  >Add a new step</button>

                                }
                            </div>
                        </DragDropContext >

                        {
                            !provider &&
                            <div className='sequence-content'>
                                <div className='sequence-type'>
                                    <h4>Create sequence that engage</h4>
                                    <p>It’s now time to be your best self and start being creative so you can impress your Buddies-to-Be. You only have one chance to make a good first impression, that’s why we’ve selected a best set of template emails to fuel your creativity</p>
                                </div>

                                <div style={{ marginLeft: '32px' }}
                                    onClick={() => {
                                        setEmailEditorData({})
                                        setTextEditorData({})
                                        setSubject('')
                                        setMessageTiny('')
                                        setSmsTiny('')
                                        if (!id) {
                                            return toast.error('Choose Campaign First.', {
                                                position: "bottom-right",
                                                closeOnClick: true,
                                            })
                                        }
                                        if (emailProvider == null) {
                                            return toast.error('Connect Email Provider First.', {
                                                position: "bottom-right",
                                                closeOnClick: true,
                                            })
                                        }
                                        setWaitFor(0)
                                        setShowBox(false)
                                        setSequence([...sequence, { _id: uuidv4(), seqType: 'Email', subject: '', message: '', order: sequence.length === 0 ? 1 : sequence.length + 1, waitFor: 0 }])
                                        setEditableIndex(sequence.length)
                                        setProvider('email')
                                        setWaitBox(sequence.length > 0 ? true : false)
                                        setLiIndex(sequence.length === 0 ? 1 : sequence.length + 1)

                                        var myDiv = document.getElementById("scroll_child");
                                        myDiv.scrollTop = myDiv.scrollHeight;
                                    }}
                                >
                                    <Row>
                                        <Col sm={4} >
                                            <div className='email-provider-div' style={{ height: '73px', width: '311px' }} >
                                                <div className='icon-div'>
                                                    <img src={EmailIcon} alt="icon" />
                                                </div>
                                                <div className='right-content'>
                                                    <div className='text'>
                                                        <p>Email</p>
                                                    </div>
                                                    <img src={RightArrow} alt="arrow" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                <Row>
                                    <Col >
                                        <div style={{ display: emailProvider == null ? 'block' : 'none', padding: '20px 40px' }} >
                                            <span>Connect your Email provider by clicking on this{' '}
                                                <Link to="/settings/email-provider">link</Link>.
                                            </span>
                                        </div>

                                    </Col>
                                </Row>

                                <div style={{ marginLeft: '32px', marginTop: emailProvider !== null ? '74px' : '20px' }}
                                    onClick={() => {
                                        setEmailEditorData({})
                                        setTextEditorData({})
                                        setSubject('')
                                        setMessageTiny('')
                                        setSmsTiny('')
                                        if (!id) {
                                            return toast.error('Choose Campaign First.', {
                                                position: "bottom-right",
                                                closeOnClick: true,
                                            })
                                        }
                                        if (textProvider == null) {
                                            return toast.error('Connect SMS Provider First.', {
                                                position: "bottom-right",
                                                closeOnClick: true,
                                            })
                                        }
                                        setWaitFor(0)
                                        setShowBox(false)
                                        setSequence([...sequence, { _id: uuidv4(), seqType: 'SMS', message: '', order: sequence.length === 0 ? 1 : sequence.length + 1, waitFor: 0 }])
                                        setEditableIndex(sequence.length)
                                        setProvider('text')
                                        setWaitBox(sequence.length > 0 ? true : false)
                                        setLiIndex(sequence.length === 0 ? 1 : sequence.length + 1)

                                        var myDiv = document.getElementById("scroll_child");
                                        myDiv.scrollTop = myDiv.scrollHeight;
                                    }}
                                >
                                    <Row>
                                        <Col sm={4} >
                                            <div className='email-provider-div' style={{ height: '73px', width: '311px' }}  >
                                                <div className='icon-div'>
                                                    <img src={TextIcon} alt="icon" />
                                                </div>
                                                <div className='right-content'>
                                                    <div className='text'>
                                                        <p>SMS</p>
                                                    </div>
                                                    <img src={RightArrow} alt="arrow" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>


                                </div>

                                <Row>
                                    <Col  >
                                        <div style={{ display: textProvider == null ? 'block' : 'none', padding: emailProvider == null ? '20px 41px 20px 41px' : '41px 41px 20px 41px' }} >
                                            <span>Connect your SMS provider by clicking on this{' '}
                                                <Link to="/settings/text-provider">link</Link>.
                                            </span>
                                        </div>

                                    </Col>
                                </Row>

                            </div>
                        }

                        {
                            provider === 'email' &&
                            <div className='sequence-content sequence_content_text_campaign'>
                                <div className='sequence_type_email_campaign'>
                                    <div className='subject_container' >
                                        <div className='subject_container_subject' >
                                            <span className='subject_container_subject_name' >Subject: </span>
                                        </div>
                                        <div className='subject_border' ></div>
                                        <div className='subject_container_subject_input' >
                                            <input className='email_editor_subject_input'
                                                type='text'
                                                value={subject}
                                                maxLength='300'
                                                onChange={(e) => {
                                                    // setIsDirty()  //change onKeyup
                                                    setSubject(e.target.value)
                                                    sequence[editableIndex]['subject'] = e.target.value
                                                }}
                                                onKeyUp={() => setIsDirty()}
                                            />
                                            {
                                                sequenceThreadData && sequenceThreadData.length > 0 && (
                                                    <div className='down_container' >
                                                        <select id="thread_select"
                                                            onChange={(e) => {
                                                                setSubject(e.target.value)
                                                                sequence[editableIndex]['subject'] = e.target.value
                                                            }}
                                                        >
                                                            <option disabled selected value="" className="outbond-fields">Select</option>
                                                            {
                                                                sequenceThreadData && sequenceThreadData.length > 0 && sequenceThreadData.map((item, i) => (
                                                                    <option value={item.subject} key={i} >{item.subject}</option>   
                                                                ))
                                                            } 
                                                        </select>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className='email_campaign_editor' style={{ marginLeft: '17px', }} >
                                    <Editor
                                        apiKey="91q8iwhlpgvrqjo15jnx6nguiflh49gxd2sb9luqq4k9n5mi"
                                        onInit={(evt, editor) => editorEmailRef.current = editor}
                                        value={messageTiny}
                                        init={{
                                            height: 'calc(100vh - 220px)',
                                            a11y_advanced_options: true, //new
                                            paste_data_images: true, //new
                                            selector: 'textarea',   //new
                                            image_advtab: true, //new
                                            // image_dimensions: false, //new
                                            image_class_list: [    //new
                                                { title: 'selectedImage', value: 'selectedImage' },
                                            ],
                                            content_style: 'img.selectedImage { border-radius: 50%; object-fit: cover;}',
                                            menubar: false,
                                            // menubar: 'table',
                                            toolbar_location: 'bottom',
                                            plugins: [
                                                'advlist autolink lists link image',
                                                'charmap print preview anchor help',
                                                'searchreplace visualblocks code',
                                                'insertdatetime media table paste wordcount',
                                                'table'
                                            ],
                                            toolbar:
                                                'undo redo forecolor backcolor | mybutton formatselect | fontselect | bold italic underline | link image | alignleft aligncenter alignright | bullist numlist outdent indent | table | help ',
                                            image_title: true,
                                            automatic_uploads: true,
                                            file_picker_types: 'image',
                                            /* and here's our custom image picker*/
                                            file_picker_callback: function (cb, value, meta) {
                                                var input = document.createElement('input');
                                                input.setAttribute('type', 'file');
                                                input.setAttribute('accept', 'image/*');
                                                input.onchange = async function () {
                                                    var file = this.files[0];
                                                    const fileLink = await uploadImage(file)
                                                    var reader = new FileReader();
                                                    reader.onload = function () {
                                                        var id = 'blobid' + (new Date()).getTime();
                                                        var blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
                                                        var base64 = reader.result.split(',')[1];
                                                        var blobInfo = blobCache.create(id, file, base64);
                                                        blobCache.add(blobInfo);
                                                        cb(fileLink, { title: file.name, id: "selectedImage" });
                                                    };
                                                    reader.readAsDataURL(file);
                                                };
                                                input.click();
                                            },

                                            // dropdown
                                            setup: function (editor) {
                                                editor.ui.registry.addMenuButton('mybutton', {
                                                    text: 'Custom Variables',
                                                    fetch: async function (callback) {
                                                        var items = await editorDropDown(editor);
                                                        callback(items);
                                                    }
                                                });

                                            },
                                        }}
                                        onEditorChange={handleEmailEditorChange}
                                        onKeyUp={() => setIsDirty()}
                                    />

                                </div>


                            </div>
                        }

                        {
                            provider === 'text' &&
                            <div className='sequence-content sequence_content_text_campaign'>
                                <div className='sequence-type' style={{ padding: '10px' }}>
                                </div>

                                <div className='text_campaign_editor' style={{ marginLeft: '32px', }} >
                                    <Editor
                                        apiKey="91q8iwhlpgvrqjo15jnx6nguiflh49gxd2sb9luqq4k9n5mi"
                                        onInit={(evt, editor) => editorTextRef.current = editor}
                                        value={smsTiny}
                                        init={{
                                            // height: 'calc(100vh - 153px)',
                                            height: 'calc(100vh - 170px)',
                                            a11y_advanced_options: true, //new
                                            paste_data_images: true, //new
                                            selector: 'textarea',   //new
                                            image_advtab: true, //new
                                            // image_dimensions: false, //new
                                            image_class_list: [    //new
                                                { title: 'selectedImage', value: 'selectedImage' },
                                            ],
                                            content_style: 'img.selectedImage { border-radius: 50%; object-fit: cover;}',
                                            menubar: false,
                                            // menubar: 'table',
                                            toolbar_location: 'bottom',
                                            plugins: [
                                                'advlist autolink lists link image',
                                                'charmap print preview anchor help',
                                                'searchreplace visualblocks code',
                                                'insertdatetime media table paste wordcount',
                                                'table'
                                            ],
                                            toolbar:
                                                // 'undo redo forecolor backcolor | formatselect | fontselect | bold italic underline | link image | alignleft aligncenter alignright | bullist numlist outdent indent | table | help ',
                                                'undo redo | mybutton fontselect | bold italic underline | link | help ',
                                            image_title: true,
                                            automatic_uploads: true,
                                            file_picker_types: 'image',
                                            /* and here's our custom image picker*/

                                            // dropdown
                                            setup: function (editor) {
                                                editor.ui.registry.addMenuButton('mybutton', {
                                                    text: 'Custom Variables',
                                                    fetch: async function (callback) {
                                                        var items = await editorDropDown(editor);
                                                        callback(items);
                                                    }
                                                });

                                            },
                                            // dropdown
                                        }}
                                        onEditorChange={handleTextEditorChange}
                                        onKeyUp={() => setIsDirty()}
                                    />

                                </div>


                            </div>
                        }
                    </div>
                </div>


            </div>


            <Modal
                size="md"
                className='warning-modal'
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className='warning-div'>
                        <img src={warningIcon} alt="warning" />
                        <h2>Warning</h2>
                        <p>Are you sure you want to delete this step?
                        </p>
                        <div className='btn-container'>
                            <button className='cancel-btn' onClick={() => setSmShow(false)}>No</button>
                            <button className='solid-button' style={{ flex: "0 0 128px" }} onClick={() => {
                                handleDeleteSequence(sequence, deleteIndex)
                            }}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                size="md"
                className='warning-modal'
                show={smShow2}
                onHide={() => setSmShow2(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className='warning-div'>
                        <img src={warningIcon} alt="warning" />
                        <h2>Warning</h2>
                        <p>Are you sure you want to delete this campaign?
                        </p>
                        <div className='btn-container'>
                            <button className='cancel-btn' onClick={() => setSmShow2(false)}>No</button>
                            <button className='solid-button' style={{ flex: "0 0 128px" }} onClick={handleDeleteCampaign} >
                                Yes
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {Prompt}
        </>
    )
}

export default CampaignDetails

